import { useDispatch, useSelector } from "react-redux";
import { languageOptions } from "../common/Config";
import { getLangBySlug, getSlugByLang } from "../common/Helper";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";
import { setLanguage } from "../redux/user/user.action";

export const SyncLangFromURL = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const hasSynced = useRef(false);

    useEffect(() => {
        if (hasSynced.current) return;
        hasSynced.current = true;

        const pathParts = location.pathname.split('/');
        const currentPathLang = pathParts[1];
        const label = getLangBySlug(currentPathLang) || "English";
        const option = languageOptions.find(opt => opt.label === label);
        if (!option) return;

        const fromLang = 'en';
        const toLang = option.value;

        // --- reset /en ---
        if (toLang === 'en') {
            document.cookie = "googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            sessionStorage.removeItem("googtrans");

            // navigate only if not already in /en
            if (!location.pathname.startsWith("/en")) {
                navigate("/en" + location.search + location.hash, { replace: true });
            }

            dispatch(setLanguage("English"));
            return;
        }

        // --- translate ---
        document.cookie = `googtrans=/${fromLang}/${toLang}; path=/`;
        sessionStorage.setItem("googtrans", `/${fromLang}/${toLang}`);

        let tries = 0;
        const interval = setInterval(() => {
            const select = document.querySelector(".goog-te-combo");
            if (select && select.value !== toLang) {
                select.value = toLang === "pt" ? "pt-PT" : toLang;
                select.dispatchEvent(new Event("change", { bubbles: true }));
                dispatch(setLanguage(label));
                clearInterval(interval);
            }
            if (++tries > 10) clearInterval(interval);
        }, 300);

        return () => clearInterval(interval);
    }, [location.pathname]);

    return null;
};
